<template>
  <div class="welPage">
    <div class="title-cover" @click.stop="showQr = false">
      <div class="line"></div>
      <!-- <img class="cover-img" draggable="false" src="../../assets/img/pc/bg.png" alt=""> -->
      <div class="slogan-box" v-if="appInfo && appInfo.slogan" v-html="util.formatTextBr(appInfo.slogan)"></div>
      <div class="qr-box" v-show="showQr" @click.stop="">
        <img src="../../assets/img/pc/qrpc.png" alt="">
        <div class="close" @click.stop.stop="showQr = false"></div>
      </div>
      <div class="enter-btn" @click.stop="runEnter">
        开启VR旅程
      </div>
      <div class="join-btn pointer" :class="{'wait-alert': !appInfo.extUrl}" @click.stop="openNewTab(appInfo.extUrl)">招商</div>
      <div class="buy-btn pointer" :class="{'wait-alert': !appInfo.weSiteUrl}" @click.stop="showQr = true">官方商城</div>
      <div class="btns-box">
        <div class="item">
          <div class="item-title">
            区域导览
          </div>
          <div class="item-text">
           {{appInfo.description}}
          </div>
          <div class="item-btn pointer" @click.stop="showMap">
            <p>地图导览</p>
            <i></i>
          </div>
        </div>
        <div class="item">
          <div class="item-title">
            全程追溯
          </div>
          <div class="item-text">
           通过区块链技术，产品生产流通环节全程在线
          </div>
          <div class="item-btn pointer" :class="{'wait-alert': !appInfo.qrCodeName}" @click.stop="showSearchPage">
            <p>溯源查询</p>
            <i></i>
          </div>
        </div>
        <div class="item">
          <div class="item-title">
            在线购买
          </div>
          <div class="item-text">
           通过官方渠道直接购买有保证的最新产品
          </div>
          <div class="item-btn pointer" @click.stop="showQr = true">
            <p>在线购买</p>
            <i></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welPage',
  props: {
    appInfo: Object,
    url: String,
    APPID: String
  },
  data () {
    return {
      showQr: false,
      couldClick: true
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    openNewTab (url) {
      if (url) {
        window.open(url)
      }
    },
    buyOnline () {

    },
    runEnter () {
      this.showQr = false
      this.$emit('runEnter', false)
    },
    showMap () {
      this.$emit('showMap', false)
    },
    showSearchPage () {
      this.$emit('showSearchPage', false)
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/40)*1rem;
  }

  .welPage{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 999;
    opacity: 1;
    &.fade-enter{
      /*opacity: 0;*/
    }
    &.fade-enter-active{
      /*transition: opacity 3s;*/
    }
    &.fade-leave-to{
      opacity: 0;
    }
    &.fade-leave-active{
      transition: opacity 1.5s;
    }
  }
  .title-cover{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background:linear-gradient(117deg,rgba(0,0,0,0.22) 0%,rgba(0,0,0,0.5) 100%);
    .cover{
      width: 100%;
      height: 100%;
    }
    .cover-img {
      width: 100vw;
      height: 100vh;
      display: block;
    }
    .slogan-box {
      font-size:rem(60);
      font-weight:600;
      color:rgba(255,255,255,1);
      line-height:rem(80);
      letter-spacing:rem(7);
      position: absolute;
      left: rem(137);
      top: rem(150);
    }
    .qr-box {
      position: absolute;
      left:50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: rem(412);
      height: rem(515);
      z-index: 999;
      img {
        width: 100%;
      }
      .close {
        position: absolute;
        right: 0;
        top: 0;
        width: rem(40);
        height: rem(40);
        cursor: pointer;
      }
    }
    .enter-btn {
      width:rem(240);
      height:rem(80);
      background:rgba(255,255,255,1);
      position: absolute;
      left: rem(137);
      bottom: rem(130);
      font-size:rem(24);
      font-weight:400;
      color:rgba(34,34,34,1);
      line-height:rem(80);
      letter-spacing:rem(1);
      text-align: center;
      cursor: pointer;
    }
    .join-btn {
      font-size:rem(14);
      color:rgba(255,255,255,1);
      position: absolute;
      right: rem(126);
      top: rem(40);
    }
    .buy-btn {
      font-size:rem(14);
      color:rgba(255,255,255,1);
      position: absolute;
      right: rem(40);
      top: rem(40);
    }
    .join-btn, .buy-btn{
      &::after{
        display: none;
        content: ' ';
        font-size: rem(14);
        line-height: rem(20);
        padding: rem(5) rem(20);
        color: #ffffff00;
        background: rgba(0,0,0,0);
        border-radius: rem(4);
        white-space: nowrap;
        position: absolute;
        right: 0;
        bottom: rem(-35);
      }
      &.wait-alert:hover{
        &::after{
          display: block;
        }
      }
    }
    .line {
      position: absolute;
      left: rem(20);
      right: rem(20);
      top: rem(20);
      bottom: rem(20);
      border: 1px solid rgba(255, 255, 255, 0.445);
      border-radius: 3px;
    }
    .btns-box  {
      position: absolute;
      right: rem(40);
      bottom: rem(120);
      height: rem(300);
      display: flex;
      color:rgba(255,255,255,1);
      justify-content: center;
      .item {
        width: rem(220);
        border-left: 1px solid #fff;
        > div {
          width: rem(160);
          margin: auto;
        }
        .item-title {
          font-size:rem(32);
          color:rgba(255,255,255,1);
          letter-spacing:rem(2);
          margin-top: rem(23);
          line-height: rem(32);
        }
        .item-text {
          font-size:rem(18);
          color:rgba(255,255,255,1);
          letter-spacing:rem(2);
          line-height: rem(25);
          margin-top: rem(92);
        }
        .item-btn {
          font-size:rem(18);
          color:rgba(255,255,255,1);
          letter-spacing:rem(2);
          line-height: rem(25);
          margin-top: rem(15);
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: rem(50);
          border-top: 1px solid #fff;
          position: relative;
          &::after{
            display: none;
            content: ' ';
            font-size: rem(14);
            line-height: rem(20);
            padding: rem(5) rem(20);
            color: #ffffff;
            background: rgba(0,0,0,0.6);
            border-radius: rem(4);
            position: absolute;
            left: 0;
            top: rem(-20);
          }
          &.wait-alert:hover{
            &::after{
              display: block;
            }
          }
          i {
            width: rem(24);
            height: rem(24);
            background:
                url('../../assets/img/pc/go.png')
                no-repeat
                scroll
                center center / cover
                content-box content-box;
          }
        }
      }
    }
  }
</style>
